/**
 * Side-effect-only bootstrap module, imported first by main.tsx.
 *
 * ES modules are loaded in dependency order: any side-effect import at the
 * top of a file is fully resolved (including its top-level code) before the
 * next import begins resolving. By isolating the telemetry fetch guard into
 * its own bootstrap file and importing it before posthog-js / @logtail/browser,
 * we guarantee `window.fetch` is wrapped BEFORE those SDKs' module-level code
 * has a chance to capture a reference to the unwrapped original.
 *
 * This matters because some SDKs grab `const fetch = window.fetch` at module
 * load time rather than on each call. If we installed the guard inline in
 * main.tsx between imports, ESM hoisting would run those SDK imports first
 * and our wrap would be ineffective.
 *
 * Keep this file as minimal as possible. Anything that needs to run before
 * anything else belongs here; everything else belongs in main.tsx.
 */

import { installTelemetryFetchGuard } from './utils/telemetryFetchGuard';

installTelemetryFetchGuard();
